import React from "react";

export default function ReviewCard({ avatar, name, role, rating, quote }) {
  const stars = Array.from({ length: 5 }).map((_, i) => (i < rating ? "★" : "☆"));
  return (
    <article className="card reviewCard">
      <div className="reviewTop">
        <img className="avatar" src={avatar} alt={name} />
        <div>
          <div className="reviewName">{name}</div>
          <div className="small">{role}</div>
        </div>
        <div className="stars" aria-label={`${rating} out of 5 stars`}>
          {stars.join("")}
        </div>
      </div>
      <p className="reviewQuote">“{quote}”</p>
    </article>
  );
}
